import { apiHelper } from './../utils/helpers'


export default {
  signIn({ account, password }) {
    return apiHelper.post('/signin', {
      account,
      password
    })
  },
  get(){
    return apiHelper.get('/admin/users')
  }
}